<template>
    <div class="or-feedback padding-top-50">
        <div class="layout-1200">
            <div class="form padding-top-40">
                <p class="title">Напишите нам</p>
                <div class="content flex-row">
                    <div class="left flex-column">
                        <or-input :error="error.state && !inputs.name" ref="name" @change="(e) => inputs.name = e.target.value" :options="{
                                                title: 'Ваше имя *',
                                                type: 'text',
                                                required: true,
                                                placeholder: 'Имя...',
                                            }"/>
                        <or-input :error="error.state && !inputs.company"  ref="company" @change="(e) => inputs.company = e.target.value" :options="{
                                                title: 'Наименование организации',
                                                type: 'text',
                                                required: false,
                                                placeholder: 'Организация...',
                                            }"/>
                        <or-input :error="error.state && !inputs.mail || error.email" ref="email" @change="(e) => inputs.mail = e.target.value" :options="{
                                                title: 'Ваша почта *',
                                                type: 'text',
                                                required: true,
                                                placeholder: 'Username@email.com...',
                                            }"/>
                        <or-input ref="phone" @change="(e) => inputs.phone = e.target.value" :options="{
                                                title: 'Ваш телефон',
                                                type: 'text',
                                                required: false,
                                                placeholder: '+7 (123) 456-78-90...',
                                            }"/>
                    </div>
                    <div class="right flex-column column-flex-end">
                        <or-textarea :error="error.state && !inputs.text" ref="text" @change="(e) => inputs.text = e.target.value" :options="{
                                                title: 'Ваше сообщение *',
                                                required: true,
                                                placeholder: 'Сообщение...',
                                            }"/>

                        
                        <div class="flex-row row-ver-center">
                            <p class="message error" v-show="error.state">{{error.text}}</p>
                            <img class="loader-img" v-if="sending.state" src="../../assets/logo-loader.svg"/>
                            <p class="message sending" v-show="sending.state">{{sending.text}}</p>
                            <p class="message success" v-show="success.state">{{success.text}}</p>
                            <or-button @click="send" :options="{
                                                                    text: 'Отправить',
                                                                    class: 'fill-button',
                                                                    style: {
                                                                        width: '194px',
                                                                        height: '45px',
                                                                        borderRadius: '8px',
                                                                    },
                                                                    animation: 'anim-main-button'
                                                                }"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import orInput from "./or-input.vue"
import orTextarea from "./or-textarea.vue"
import orButton from "./or-button.vue"
import Axios from 'axios'
import { mapGetters } from 'vuex'
export default {
    props: {
        settings: Object,
    },
    components: {orInput, orTextarea, orButton},
    data() {
        return {
            inputs: {
                name: "",
                company: "",
                mail: "",
                phone: "",
                text: "",
            },
            error: {
                state: false,
                text: 'Заполните обязательные поля, пожалуйста!',
                email: false,
            },
            sending: {
                state: false,
                text: 'Отправляем письмо, подождите немного!'
            },
            success: {
                state: false,
                text: 'Письмо отправлено успешно!'
            }

        }
    },
    watch: {
        settings(from, to) {
            this.$refs.name.$refs.input.focus();
        }
    },
    computed: {
        ...mapGetters({info: 'getInfo'}),
    },
    methods: {
        send() {
            if (!this.inputs.name || !this.inputs.mail || !this.inputs.text || !this.inputs.company) {
                this.success.state = false;
                this.error.text = 'Заполните обязательные поля, пожалуйста!';
                this.error.state = true;
                this.error.email = false;
                return;
            } else if (this.inputs.mail && (!this.inputs.mail.includes('@') || !this.inputs.mail.includes('.') || this.inputs.mail.slice(this.inputs.mail.length - 1) === '.')) {
                this.success.state = false;
                this.error.text = 'Проверьте, пожалуйста, почту, что-то с ней не так!';
                this.error.state = true;
                this.error.email = true;
                return;
            } else {
                this.success.state = false;
                this.error.state = false;
                this.sending.state = true;
                this.error.email = false;
            }
            Axios.post('/api/sendMail', {
                service: this.info.service,
                user: this.info.user,
                pass: this.info.pass,
                our_mail: this.info['feedback-email'],
                client_name: this.inputs.name,
                client_company: this.inputs.company,
                client_mail: this.inputs.mail,
                client_phone: this.inputs.phone ? this.inputs.phone : 'Телефон не указан',
                client_text: this.inputs.text,
            })
                .then(({data})=>{
                    this.sending.state = false;
                    this.success.state = true;
                })
        }
    }
}
</script>

<style scoped>
    .or-feedback {
        height: 648px;
        background-image: url(../../assets/feedback-bg.jpg);
        background-position: center;
        background-size: cover;
    }
    .form {
        height: 548px;
        background-color: rgba(30,30,30,0.9);
        border-radius: 8px;
        padding-bottom: 60px;
    }
    .left {
        margin-right: 40px;
    }
    .title {
        font-size: 24px;
        line-height: 36px;
        margin-bottom: 32px;
        margin-left: 40px;
        text-align: left;
    }
    .content {
        margin-left: 40px;
        margin-bottom: 60px;
    }
    .message {
        margin-right: 20px;
    }
    .error {
        color: #932727;
        font-size: 14px;
        line-height: 16px;
        text-align: right;
    }
    .sending {
        color: white;
        font-size: 14px;
        line-height: 16px;
        text-align: right;
    }
    .success {
        color: #EBB932;
        font-size: 14px;
        line-height: 16px;
        text-align: right;
    }
    @keyframes loader {
        from {transform: rotate(0);}
        to {transform: rotate(1080deg);}
    }
    .loader-img {
        margin-right: 20px;
        width: 40px;
        animation-name: loader;
        animation-duration: 2s;
        animation-iteration-count: infinite;
        animation-timing-function: ease-in-out;
    }

</style>